import React, { PropsWithChildren } from 'react';

import { IBaseLevel } from 'client/common/types';

import HtmlContent from '../html-content';

import { b, ILevelProps } from './index';

function Level({
    key,
    innerRef,
    className,
    children,
    title,
    subtitle,
    description
}: PropsWithChildren<ILevelProps> & IBaseLevel) {
    return (
        <div
            key={key}
            ref={innerRef}
            className={b({}, [className])}
            >
            {title && (
                <h2
                    className={b('title')}
                    dangerouslySetInnerHTML={{ __html: title }}
                    />
            )}
            {subtitle && (
                <h3
                    className={b('subtitle')}
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                    />
            )}
            {description && (
                <HtmlContent
                    className={b('description')}
                    content={description}
                    />
            )}
            {children}
        </div>
    );
}

export default Level;
